<template>
  <div
    class="modal fade"
    id="hospitalInfoWModal"
    tabindex="-1"
    aria-labelledby="hospitalInfoWModallLabel"
    aria-hidden="true"
    style="overflow-x: hidden"
  >
    <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header text-center">
          <div class="modal_header_flex" >
            <h1 class="modal-title fs-5" id="staticBackdropLabel">
              병원 등록하기
            </h1>
          </div>
        </div>
        <div class="modal-division"/>
        <div class="modal-body" style="padding-top: 1rem">

          <div class="modalDivWrap">
            <div class="modalPartTitle">병원 정보 등록</div>
            <div class="modalInputDiv">
              <label>사업자등록번호<span class="requiredSpan">*</span></label>
              <input
                type="text"
                placeholder="사업자등록 번호를 입력해주세요(ex. 123-45-67890)"
                v-model="businessNumber"
                maxlength="12"
                @input="changeBusinessNumber"
                @keyup.enter="businessNumberValidate"
              />
              <div class="modalInputRight">
                <button
                  class="btn btn-primary modalBtnRight"
                  style="margin-bottom: 0!important;"
                  @click="businessNumberValidate()"
                >
                  중복확인
                </button>
              </div>
            </div>
            <div class="modalInputDiv" style="padding: 0!important">
              <label/>
              <span class="businessNumberMsgW fail"></span>
              <div class="modalInputRight"/>
            </div>
            <div class="modalInputDiv">
              <label>사업자등록증</label>
              <button 
                class="btn btn-primary"
                @click="openBusinessFileInput()"
                style="margin-bottom: 0!important;"
              >등록증 업로드</button>
              <div v-if="businessFileName" class="fileNameWrap">
                <span 
                  class="imgspan hoverPointer" 
                  style="margin-left: 10px; width: 40%; overflow: hidden;"
                  @click="downloadBusinessNumImage()"
                  >{{ businessFileName }}
                </span>
                <button class="btn-close" 
                @click="deleteBusinessNumImage()"
                style=""/>
              </div>
              
              <input
              type="file"
              id="businessFileInputW"
              ref="businessFileInputW"
              @change="changeBusinessNumImage()"
              />
            </div>
            <div class="modalInputDiv">
              <label>테스트 병원 여부</label>
              <div class="radioWrap">
                <div class="radioObj">
                  <a-checkbox
                    v-model:checked="isTestCompany"
                    id="isTestCompanyW"
                  />
                </div>
              </div>
            </div>
            <div class="modalInputDiv">
              <label>국가 선택<span class="requiredSpan">*</span></label>
              <select
                v-model="selectedLocale"
                @change="onLocaleChange"
                style="
                  width: 30%;
                  border-radius: 5px;
                  border-width: 1px;
                  height: 35px;"
              >
                <option
                  v-for="option in countryOptions"
                  :value="option.value"
                  :key="option.value"
                >{{ option.label }}</option>
              </select>
              <div class="modalInputRight"/>
            </div>
            <div class="modalInputDiv">
              <label>진료 과목<span class="requiredSpan">*</span></label>
              <div class="radioWrap">
                <div class="radioObj" v-for="(item, i) in deptList" :key="i">
                  <input 
                  type="checkbox" 
                  :value="item.code"
                  :id="item.code+'W'"
                  v-model="medicalDept"
                  /> 
                  <label :for="item.code+'W'">{{ item.name }}</label>
                </div>
              </div>
              <div class="modalInputRight"/>
            </div>
            <div class="modalInputDiv">
              <label>지역 구분<span class="requiredSpan">*</span></label>
              <select v-model="selectedAreaFirst" style="
                width: 15%;
                border-radius: 5px;
                border-width: 1px;
                height: 35px;" id="itemCode"
                @change="areaSecondChange()"
              >
                <option value="" selected>시/도 선택</option>
                <option v-for="item in areaFirst" :value="item" :key="item">{{ `${item}` }}</option>
              </select>
              <select v-model="selectedAreaSecond" style="
                width: 15%;
                border-radius: 5px;
                border-width: 1px;
                margin-left: 20px;
                height: 35px;" id="itemCode"
                @change="areaThirdChange()"
              >
                <option value="" selected>시/군/구 선택</option>
                <option v-for="item in areaSecond" :value="item" :key="item">{{ `${item}` }}</option>
              </select>
              <select v-model="selectedAreaThird" style="
                width: 15%;
                border-radius: 5px;
                border-width: 1px;
                margin-left: 20px;
                height: 35px;" id="itemCode"
              >
                <option value="" selected>읍/면/동 선택</option>
                <option v-for="item in areaThird" :value="item" :key="item">{{ `${item}` }}</option>
              </select>
            </div>
            <div class="modalInputDiv">
              <label>상세 주소</label>
              <input
                type="text"
                placeholder="나머지 상세주소를 입력하세요."
                v-model="addrDetail"
              />
              <div class="modalInputRight"/>
            </div>
            <div class="modalInputDiv">
              <label>병원명<span class="requiredSpan">*</span></label>
              <input
                type="text"
                placeholder="사업자등록증에 등록된 병원명을 입력하세요."
                v-model="hospitalName"
              />
              <div class="modalInputRight"/>
            </div>
            <div class="modalInputDiv">
              <label>병원장명</label>
              <input
                type="text"
                placeholder="사업자등록증에 등록된 병원장명을 입력하세요."
                v-model="hospitalCeoName"
              />
              <div class="modalInputRight"/>
            </div>
            <div class="modalInputDiv">
              <label>대표 전화번호</label>
              <input
                type="text"
                :placeholder="phonePlaceholder"
                v-model="hospitalPhoneNumber"
                maxlength="20"
                @input="changeHospitalPhoneNumber"
              />
              <div class="modalInputRight">

              </div>
            </div>
            <div class="modalInputDiv">
              <label>요양기관 코드</label>
              <input
                type="text"
                placeholder="병원의 요양기관 코드를 입력해주세요(ex.11111111)."
                v-model="hospitalCode"
              />
              
              <div class="modalInputRight">
              </div>
            </div>
             <div class="modalInputDiv" style="align-items: start;">
              <label style="margin-top: 10px;">재직 의사</label>
              <div class="rowsWrap">
                <div 
                class="doctorRow"
                v-for="(item, i) in doctors"
                >
                  <div class="doctorInput">
                    <input 
                    type="text" 
                    placeholder="병원에 재직중인 의사 이름을 입력해주세요."
                    v-model="doctors[i]"
                    />
                  </div>
                  <div class="modalInputRight">
                    <button 
                    v-if="i===doctors.length-1"
                    class="btn btn-primary modalBtnRight" 
                    style="margin-bottom: 0!important;" 
                    @click="addRow()">
                      +
                    </button>
                    <button 
                    v-if="i>0 || doctors.length > 1"
                    class="btn btn-primary modalBtnRight" 
                    style="margin-bottom: 0!important;" 
                    @click="deleteRow(i)">
                      -
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div style="padding: 10px 0; display: flex; justify-content: center;"/>
            <div class="modalInputDiv">
              <label>페이지 로고</label>
              <button 
                class="btn btn-primary"
                @click="openLogoFileInput()"
                style="margin-bottom: 0!important;"
              >이미지 업로드</button>
              <input
              type="file"
              id="logoFileInputW"
              accept="image/jpeg, image/png"
              ref="logoFileInputW"
              @change="changeLogoImage()"
              />
            </div>
            <div class="modalInputDiv">
              <label/>
              <div class="logoFileNameWrap">
                <span class="imgspan"
                > 
                <img src="#" alt="" id="logoPrevW" class="hoverPointer" @click="downloadLogoImage()" />
                </span>
                <div v-if="logoFileName">
                  <span 
                  class="imgspan hoverPointer"
                  @click="downloadLogoImage()"
                  >{{logoFileName}}</span>
                  <button class="btn-close" 
                  @click="deleteLogoImage()"
                  style=""/>
                </div>
              </div>
            </div>
            <div class="modalInputDiv">
              <label/>
              <div class="modalTextSmall">
                이미지 권장 사이즈는 300*60입니다. 파일 크기는 최대 100MB까지 등록 가능합니다.
              </div>
            </div>
            <div style="padding: 10px 0; display: flex; justify-content: center;"/>
            <div class="modalInputDiv">
              <label>배너 이미지</label>
              <button 
                class="btn btn-primary"
                @click="openBannerFileInput()"
                style="margin-bottom: 0!important;"
              >이미지 업로드</button>
              <input
              type="file"
              id="bannerFileInputW"
              accept="image/jpeg, image/png"
              ref="bannerFileInputW"
              @change="changeBannerImage()"
              />
            </div>
            <div class="modalInputDiv">
              <label/>
              <div class="logoFileNameWrap">
                <span class="imgspan"
                > 
                <img src="#" alt="" id="bannerPrevW" class="hoverPointer" @click="downloadBannerImage()" />
                </span>
                <div v-if="bannerFileName">
                  <span 
                  class="imgspan hoverPointer"
                  @click="downloadBannerImage()"
                  >{{bannerFileName}}</span>
                  <button class="btn-close" 
                  @click="deleteBannerImage()"
                  style=""/>
                </div>
              </div>
            </div>
            <div class="modalInputDiv">
              <label/>
              <div class="modalTextSmall">
                이미지 권장 사이즈는 300*60입니다. 파일 크기는 최대 100MB까지 등록 가능합니다.
              </div>
            </div>
          </div>
          <div class="modalDivWrap">
            <div class="modalPartTitle">관리자 정보 등록</div>
            <div class="modalInputDiv">
              <label>관리자 이름</label>
              <input
                type="text"
                placeholder="해당 병원의 관리자 이름을 입력해주세요."
                v-model="managerName"
              />
              <div class="modalInputRight"/>
            </div>
            <div class="modalInputDiv">
              <label>관리자 직급</label>
              <input
                type="text"
                placeholder="관리자의 직급을 입력해주세요."
                v-model="managerDuty"
              />
              <div class="modalInputRight"/>
            </div>
            <div class="modalInputDiv">
              <label>관리자 연락처</label>
              <input
                type="text"
                :placeholder="managerPhonePlaceholder"
                v-model="managerPhoneNumber"
                maxlength="20"
                @input="changeManagerPhoneNumber"
                />
              <div class="modalInputRight"/>
            </div>
            <input
              type="text"
              placeholder="관리자의 아이디를 입력해주세요."
              style="display: none!important;"
            />
            <input
              type="password"
              placeholder="비밀번호를 입력해주세요."
              @input="passwordOnChange"
              style="display: none!important;"
            />
            <div class="modalInputDiv">
              <label>관리자 아이디</label>
              <input
                type="text"
                placeholder="관리자의 아이디를 입력해주세요."
                v-model="managerId"
                @keyup.enter="managerIdValidate"
                @input="changeManagerId"
              />
              <div class="modalInputRight">
                <button
                  class="btn btn-primary modalBtnRight"
                  style="margin-bottom: 0!important;"
                  @click="managerIdValidate()"
                >
                  중복확인
                </button>
              </div>
            </div>
            <div class="modalInputDiv" style="padding: 0!important">
              <label/>
              <span class="managerIdMsgW fail"></span>
              <div class="modalInputRight"/>
            </div>
            <div class="modalInputDiv">
              <label>관리자 비밀번호</label>
              <input
                type="password"
                placeholder="비밀번호를 입력해주세요."
                v-model="password"
                @input="passwordOnChange"
                />
                <div class="modalInputRight">
                </div>
              </div>
              <div class="modalInputDiv">
                <label>비밀번호 확인</label>
                <input
                type="password"
                placeholder="비밀번호를 다시 입력해주세요."
                v-model="passwordConfirm"
                @input="passwordOnChange"
              />
              <div class="modalInputRight"/>
            </div>
            <div class="modalInputDiv" style="padding: 0!important">
              <label/>
              <span class="passwordMsgW fail"></span>
              <div class="modalInputRight"/>
            </div>


          </div>

          <!-- 웹챗봇 설정 섹션 -->
          <div class="modalDivWrap">
            <div class="modalPartTitle">웹챗봇 설정</div>
            <div class="modalInputDiv">
              <label>
                예약 페이지 내 웹챗봇 사용
                <a-tooltip placement="top">
                  <template #title>
                    활성화 시 예약 페이지에 웹챗봇 위젯이 표시됩니다.
                  </template>
                  <QuestionCircleOutlined style="margin-left: 5px; color: #999; cursor: help;" />
                </a-tooltip>
              </label>
              <a-switch
                v-model:checked="useWebChatbotOnReservation"
                @change="onUseWebChatbotChange"
              />
              <div class="modalInputRight"/>
            </div>
            <div class="modalInputDiv" v-if="useWebChatbotOnReservation">
              <label>
                내 챗봇 사용하기
                <a-tooltip placement="top">
                  <template #title>
                    활성화 시 병원 소유의 챗봇을 사용합니다. 비활성화 시 기본 챗봇이 사용됩니다.
                  </template>
                  <QuestionCircleOutlined style="margin-left: 5px; color: #999; cursor: help;" />
                </a-tooltip>
              </label>
              <a-switch
                v-model:checked="useOwnChatbot"
                :disabled="chatbotList.length === 0"
                @change="onUseOwnChatbotChange"
              />
              <span v-if="chatbotList.length === 0" style="margin-left: 10px; color: #999; font-size: 12px;">
                (등록된 챗봇이 없습니다)
              </span>
              <div class="modalInputRight"/>
            </div>
            <div class="modalInputDiv" v-if="useWebChatbotOnReservation && useOwnChatbot">
              <label>메인 챗봇 선택</label>
              <select
                v-model="mainChatbotId"
                style="width: 70%; border-radius: 5px; border-width: 1px; height: 35px;"
              >
                <option value="">챗봇을 선택해주세요</option>
                <option
                  v-for="chatbot in chatbotList"
                  :value="chatbot._id"
                  :key="chatbot._id"
                >
                  {{ chatbot.name }} {{ chatbot.isActive ? '' : '(비활성)' }}
                </option>
              </select>
              <div class="modalInputRight"/>
            </div>
          </div>

          <!-- 외부 서비스 연동 섹션 -->
          <div class="modalDivWrap">
            <div class="modalPartTitle">외부 서비스 연동</div>

            <div class="modalInputDiv">
              <label>외부 서비스 구분</label>
              <select
                v-model="selectedServiceType"
                @change="onServiceTypeChange"
                style="width: 70%; border-radius: 5px; border-width: 1px; height: 35px;"
              >
                <option value="">서비스 구분을 선택해주세요</option>
                <option
                  v-for="type in externalServiceTypes"
                  :value="type._id"
                  :key="type._id"
                >
                  {{ type.name }}
                </option>
              </select>
              <div class="modalInputRight">
                <button
                  type="button"
                  class="btn btn-primary modalBtnRight"
                  style="margin-bottom: 0!important;"
                  @click="openServiceTypeModal()"
                >
                  추가
                </button>
              </div>
            </div>

            <!-- 서비스 타입 추가 입력 필드 -->
            <div class="modalInputDiv" v-if="showServiceTypeInput">
              <label></label>
              <input
                type="text"
                placeholder="새 서비스 타입명을 입력하세요"
                v-model="newServiceTypeName"
                @keyup.enter="saveServiceType()"
              />
              <div class="modalInputRight">
                <button
                  type="button"
                  class="btn btn-success modalBtnRight"
                  style="margin-bottom: 0!important; margin-right: 5px;"
                  @click="saveServiceType()"
                >
                  저장
                </button>
                <button
                  type="button"
                  class="btn btn-secondary modalBtnRight"
                  style="margin-bottom: 0!important;"
                  @click="cancelServiceTypeInput()"
                >
                  취소
                </button>
              </div>
            </div>

            <div class="modalInputDiv">
              <label>연동 서비스</label>
              <select
                v-model="selectedService"
                :disabled="!selectedServiceType"
                @change="onServiceChange"
                style="width: 70%; border-radius: 5px; border-width: 1px; height: 35px;"
              >
                <option value="">연동 서비스를 선택해주세요</option>
                <option
                  v-for="service in externalServices"
                  :value="service._id"
                  :key="service._id"
                >
                  {{ service.name }}
                </option>
              </select>
              <div class="modalInputRight">
                <button
                  type="button"
                  class="btn btn-primary modalBtnRight"
                  style="margin-bottom: 0!important;"
                  @click="openProviderModal()"
                  :disabled="!selectedServiceType"
                >
                  추가
                </button>
              </div>
            </div>

            <!-- 제공자 추가 입력 필드 -->
            <div class="modalInputDiv" v-if="showProviderInput">
              <label></label>
              <input
                type="text"
                placeholder="새 제공자명을 입력하세요"
                v-model="newProviderName"
                @keyup.enter="saveProvider()"
              />
              <div class="modalInputRight">
                <button
                  type="button"
                  class="btn btn-success modalBtnRight"
                  style="margin-bottom: 0!important; margin-right: 5px;"
                  @click="saveProvider()"
                >
                  저장
                </button>
                <button
                  type="button"
                  class="btn btn-secondary modalBtnRight"
                  style="margin-bottom: 0!important;"
                  @click="cancelProviderInput()"
                >
                  취소
                </button>
              </div>
            </div>

            <!-- 스케줄 종류 (DOCTOR_PALETTE 전용) -->
            <div class="modalInputDiv" v-if="showScheduleTypeSelect">
              <label>스케줄 종류</label>
              <select
                v-model="selectedScheduleType"
                style="width: 60%; border-radius: 5px; border-width: 1px; height: 35px;"
              >
                <option value="">스케줄 종류를 선택해주세요</option>
                <option
                  v-for="schedule in scheduleTypes"
                  :value="schedule.id"
                  :key="schedule.id"
                >
                  {{ schedule.name }}
                </option>
              </select>
              <div class="modalInputRight">
                <button
                  type="button"
                  class="btn btn-primary modalBtnRight"
                  style="margin-bottom: 0!important;"
                  @click="fetchScheduleTypes()"
                >
                  조회
                </button>
              </div>
            </div>

            <!-- 예약연동활성화 (DOCTOR_PALETTE 전용) -->
            <div class="modalInputDiv" v-if="showScheduleTypeSelect">
              <label>
                예약연동활성화
                <a-tooltip placement="top">
                  <template #title>
                    활성화 시, 닥터팔레트의 예약 가능 시간이 우선 적용됩니다. 닥터팔레트에서 예약 불가한 시간대는 서티라이프에서도 예약이 제한됩니다.
                  </template>
                  <QuestionCircleOutlined style="margin-left: 5px; color: #999; cursor: help;" />
                </a-tooltip>
              </label>
              <a-switch
                v-model:checked="useExternalSchedule"
              />
              <div class="modalInputRight"/>
            </div>

            <div class="modalInputDiv">
              <label>API 키</label>
              <div style="position: relative; width: 70%;">
                <input
                  :type="showApiKey ? 'text' : 'password'"
                  placeholder="API 키를 입력해주세요"
                  v-model="apiKey"
                  style="width: 100%; padding-right: 45px;"
                />
                <button
                  type="button"
                  @click="toggleShowApiKey()"
                  style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%); background: none; border: none; cursor: pointer; padding: 5px; font-size: 16px; color: #999;"
                >
                  <EyeOutlined v-if="showApiKey" />
                  <EyeInvisibleOutlined v-else />
                </button>
              </div>
              <div class="modalInputRight"/>
            </div>

            <div class="modalInputDiv">
              <label>클라이언트 ID</label>
              <div style="position: relative; width: 70%;">
                <input
                  :type="showClientId ? 'text' : 'password'"
                  placeholder="클라이언트 ID를 입력해주세요"
                  v-model="clientId"
                  style="width: 100%; padding-right: 45px;"
                />
                <button
                  type="button"
                  @click="toggleShowClientId()"
                  style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%); background: none; border: none; cursor: pointer; padding: 5px; font-size: 16px; color: #999;"
                >
                  <EyeOutlined v-if="showClientId" />
                  <EyeInvisibleOutlined v-else />
                </button>
              </div>
              <div class="modalInputRight"/>
            </div>

            <div class="modalInputDiv">
              <label>클라이언트 시크릿</label>
              <div style="position: relative; width: 70%;">
                <input
                  :type="showClientSecret ? 'text' : 'password'"
                  placeholder="클라이언트 시크릿을 입력해주세요"
                  v-model="clientSecret"
                  style="width: 100%; padding-right: 45px;"
                />
                <button
                  type="button"
                  @click="toggleShowClientSecret()"
                  style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%); background: none; border: none; cursor: pointer; padding: 5px; font-size: 16px; color: #999;"
                >
                  <EyeOutlined v-if="showClientSecret" />
                  <EyeInvisibleOutlined v-else />
                </button>
              </div>
              <div class="modalInputRight"/>
            </div>

            <div style="padding: 10px 0; display: flex; justify-content: center;">
              <span style="color: #666; font-size: 13px;">
                * 병원 등록 시 외부 서비스가 자동으로 연동됩니다.
              </span>
            </div>
          </div>
        </div>
        <div class="modal-footer" style="justify-content: center">
          <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
            style="color: #666666; background: #fff; border: 1px solid #666;"
          >
            취소
          </button>
          <button
            type="button"
            class="btn btn-info"
            @click="addHospital()"
          >
            등록하기
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { openDialog, changeBytesToKilos, businessNumberFormatter, phoneNumberFormatterByLocale } from "@/utils/utils";
import jsonFile from "@/assets/locations.json";
import {
  MedicalDept,
} from '@/utils/enums'
import {
  YnEnum
} from '@/enums/common.enums'
import { EyeOutlined, EyeInvisibleOutlined, QuestionCircleOutlined } from '@ant-design/icons-vue'
import externalServiceMixin from '@/mixins/externalServiceMixin'
import { getCountryOptions, getCountryConfig, DEFAULT_LOCALE } from "@/constants/countryPhone"

export default {
  components: {
    EyeOutlined,
    EyeInvisibleOutlined,
    QuestionCircleOutlined
  },
  mixins: [externalServiceMixin],
  data() {
    return {
      type: "HOSPITAL",
      hospitalId: "", // 병원Id (등록 후 설정됨)

      deptList: [], // 병원 구분
      areaFirst: [], // 시군구 대분류
      areaSecond: [], // 시군구 중분류
      areaThird: [], // 읍면동 소분류
      selectedAreaFirst: "", // 선택된 시군구 대분류
      selectedAreaSecond: "", // 선택된 시군구 중분류
      selectedAreaThird: "", // 선택된 읍면동 소분류
      addrDetail: "", // 상세주소
      medicalDept: [], // 선택된 병원구분

      hospitalName: "", // 병원명
      hospitalCeoName: "", // 병원장명
      hospitalPhoneNumber: "", // 병원명
      hospitalCode: "", // 요양기관 코드
      doctors: [""], // 재직 의사
      businessNumber: "", // 사업자등록번호

      managerName: "", // 관리자 이름
      managerDuty: "", // 관리자 직급
      managerPhoneNumber: "", // 관리자 연락처
      managerId: "", // 관리자 아이디
      password: "", // 관리자 비밀번호
      passwordConfirm: "", // 비밀번호 확인

      businessFileName: "", // 사업자이미지 파일명
      businessFileData: null, // 실제 사업자이미지파일 정보가 담긴 폼데이터
      businessImgUrl: "", // objectStorage 상 사업자이미지 url

      logoFileName: "", // 로고이미지 파일명
      logoFileData: null, // 실제 로고파일 정보가 담긴 폼데이터
      logoImgUrl: "", // objectStorage 상 로고이미지 url

      bannerFileName: "", // 배너이미지 파일명
      bannerFileData: null, // 실제 배너이미지파일 정보가 담긴 폼데이터
      bannerImgUrl: "", // objectStorage 상 배너이미지 url

      isTestCompany: false,

      // 검증관련 불리언, 필수값에 따라 추가
      isBusinessNumberValid: false,
      isPasswordValid: false,
      isManagerIdValid: false,
      // 외부 서비스 관련 데이터는 externalServiceMixin에서 관리

      // 웹챗봇 설정
      useWebChatbotOnReservation: false,
      useOwnChatbot: false,
      mainChatbotId: '',
      chatbotList: [],

      // 국가/지역 설정
      selectedLocale: DEFAULT_LOCALE, // 선택된 국가 코드
      countryOptions: getCountryOptions(), // 국가 선택 옵션 목록
    };
  },
  computed: {
    // 현재 선택된 국가의 전화번호 placeholder
    phonePlaceholder() {
      const config = getCountryConfig(this.selectedLocale);
      return `대표 전화번호를 입력해주세요(ex. ${config.placeholder})`;
    },
    managerPhonePlaceholder() {
      const config = getCountryConfig(this.selectedLocale);
      return `관리자의 연락처를 입력해주세요(ex. ${config.placeholder})`;
    }
  },

  async mounted() {
    this.initValues();
    this.getAreaList();
    await this.getDeptList();
    await this.getExternalServiceTypes();
  },
  methods: {
    changeHospitalPhoneNumber() {
      this.hospitalPhoneNumber = phoneNumberFormatterByLocale(this.hospitalPhoneNumber.toString(), this.selectedLocale);
    },
    changeManagerPhoneNumber() {
      this.managerPhoneNumber = phoneNumberFormatterByLocale(this.managerPhoneNumber.toString(), this.selectedLocale);
    },
    // 국가 변경 시 전화번호 재포맷
    onLocaleChange() {
      if (this.hospitalPhoneNumber) {
        this.hospitalPhoneNumber = phoneNumberFormatterByLocale(this.hospitalPhoneNumber.toString(), this.selectedLocale);
      }
      if (this.managerPhoneNumber) {
        this.managerPhoneNumber = phoneNumberFormatterByLocale(this.managerPhoneNumber.toString(), this.selectedLocale);
      }
    },
    // 병원코드, 의료종사자번호, 사업자등록번호(중복확인 필요한 값들)의 값 변경 시 valid false로 재설정
    changeBusinessNumber() {
      this.businessNumber = businessNumberFormatter(this.businessNumber);
      this.isBusinessNumberValid = false;
      if(document.querySelector(".businessNumberMsgW")) document.querySelector(".businessNumberMsgW").innerHTML = "";
    },
    changeManagerId() {
      this.isManagerIdValid = false;
      if(document.querySelector(".managerIdMsgW")) document.querySelector(".managerIdMsgW").innerHTML = "";
    },
    // 주요 API
    // 병원 등록
    async addHospital() {
      if(await this.validateData()) {
        try {
          const obj = {};
          
          const deptArr = new Array();
          this.medicalDept.forEach((ele) => {
            deptArr.push(ele);
          });

          const doctorArr = new Array();
          const filteredArray = this.doctors.filter((element) => element !== "");

          if(filteredArray.length > 0) {
            filteredArray.forEach((ele) => {
              doctorArr.push(ele);
            });
          }

          obj.medicalDept = deptArr;       
          obj.name = this.hospitalName;
          if(this.hospitalCeoName) obj.ceo = this.hospitalCeoName;
          obj.cNo = this.businessNumber.replace(/-/g, '');
          obj.addrOne = this.selectedAreaFirst;
          obj.addrTwo = this.selectedAreaSecond;
          obj.addrThree = this.selectedAreaThird;
          obj.addrDetail = this.addrDetail;
          obj.isTestCompany = this.isTestCompany ? YnEnum.Y : YnEnum.N;
          obj.locale = this.selectedLocale; // 국가/지역 코드

          if(this.businessFileData) {
            const businessImgUrl = await this.uploadImageOnObjectStorage(this.businessFileData);
            obj.cNoUrl = businessImgUrl; 
          } else {
            obj.cNoUrl = '';
          }
          if(this.logoFileData) {
            const logoImgUrl = await this.uploadImageOnObjectStorage(this.logoFileData);
            obj.imgUrl = logoImgUrl; 
          } else {
            obj.imgUrl = '';
          }
          if(this.bannerFileData) {
            const bannerImgUrl = await this.uploadImageOnObjectStorage(this.bannerFileData);
            obj.bannerUrl = bannerImgUrl; 
          } else {
            obj.bannerUrl = '';
          }

          if(this.hospitalPhoneNumber) {
            obj.call = this.hospitalPhoneNumber.replace(/-/g, '');
          } else {
            obj.call = '';
          };
          obj.hospitalCode = this.hospitalCode;
          obj.type = this.type;
          if(doctorArr.length > 0) obj.doctors = doctorArr;

          // 웹챗봇 설정
          obj.useWebChatbotOnReservation = this.useWebChatbotOnReservation;
          obj.useOwnChatbot = this.useOwnChatbot;
          if (this.useOwnChatbot && this.mainChatbotId) {
            obj.mainChatbotId = this.mainChatbotId;
          }

          const accountInfo = {};
          accountInfo.username = this.managerId.trim();
          accountInfo.password = this.password;
          accountInfo.role = this.type;
          accountInfo.name = this.managerName;
          if(this.managerDuty) accountInfo.duty = this.managerDuty;
          if(this.managerPhoneNumber) accountInfo.mobile = this.managerPhoneNumber.replace(/-/g, "");
          obj.accountInfo = accountInfo;

          // 외부 서비스 연동 정보가 있으면 DOCTOR_PALETTE 스케줄 검증
          if (this.selectedServiceType && this.selectedService && (this.apiKey || this.clientId || this.clientSecret)) {
            // DOCTOR_PALETTE인 경우 스케줄 종류 필수 검증
            if (this.showScheduleTypeSelect && !this.selectedScheduleType) {
              await openDialog("스케줄 종류를 선택해주세요.", "error", "확인");
              return;
            }
          }

          const response = await this.$apiInstance.post(`/companies`, obj);
          if(response.status === 200 || response.status === 201) {
            const newHospitalId = response.data.id || response.data._id;
            // hospitalId 설정 (mixin의 saveEmrIntegration에서 사용)
            this.hospitalId = newHospitalId;

            // 외부 서비스 연동 정보가 있으면 EMR 연동 저장
            if (this.selectedServiceType && this.selectedService && (this.apiKey || this.clientId || this.clientSecret)) {
              try {
                await this.saveEmrIntegration(newHospitalId, obj);
                await openDialog("병원 등록 및 EMR 연동이 완료되었습니다.", "success", "확인")
                  .then(() => {
                    location.reload();
                  });
              } catch (emrError) {
                console.log('EMR 연동 저장 실패:', emrError);
                await openDialog("병원은 등록되었으나 EMR 연동 설정 저장에 실패했습니다.", "warning", "확인")
                  .then(() => {
                    location.reload();
                  });
              }
            } else {
              await openDialog("병원 등록이 완료되었습니다.", "success", "확인")
                .then(() => {
                  location.reload();
                });
            }
          } else {
            await openDialog("병원 등록에 실패하였습니다.", "error", "확인");
          }
          
        } catch (error) {
          console.log(error);
          if(error.response && error.response.status === 400) {
            await openDialog(error.response.data?.message || "이미 존재하는 계정입니다.", "error", "확인");
          } else {
            await openDialog("병원 등록에 실패하였습니다.", "error", "확인");
          }
        }
      } else {
      }
    },

    // 이미지 오브젝트스토리지에 업로드
    async uploadImageOnObjectStorage(fileData) {
      const response = await this.$apiInstance.post(`/object-storages`, fileData);
      if(response.status === 200 || response.status === 201) {
        return response.data.url;
      } else {
        return "";
      }
    },


    // 사업자등록번호 validate
    async businessNumberValidate() {
      const businessNumberMsg = document.querySelector(".businessNumberMsgW");
      if (this.businessNumber.replaceAll('-','').length < 10) {
          businessNumberMsg.setAttribute("class", "businessNumberMsgW fail");
          businessNumberMsg.innerHTML = "잘못된 사업자등록번호입니다.";
          this.isBusinessNumberValid = false;
      } else {
        const response = await this.$apiInstance.get(`/companies/duplicateCheck/cNo/${this.businessNumber}`);
        if(response && (response.status === 200 || response.status === 201) && !response.data) {
          businessNumberMsg.setAttribute("class", "businessNumberMsgW success");
          businessNumberMsg.innerHTML = "사용할 수 있는 사업자등록번호입니다.";
          this.isBusinessNumberValid = true;
        } else {
          businessNumberMsg.setAttribute("class", "businessNumberMsgW fail");
          businessNumberMsg.innerHTML = "이미 존재하는 사업자등록번호입니다.";
          this.isBusinessNumberValid = false;
        }
      }
    },
    async managerIdValidate (){
      const managerIdMsgW = document.querySelector('.managerIdMsgW');
      if(!this.managerId.trim()) {
        managerIdMsgW.setAttribute("class", "managerIdMsgW fail");
        managerIdMsgW.innerHTML = "아이디를 입력해주세요.";
        this.isManagerIdValid = false;
      } else {
        try {
          const response = await this.$apiInstance.get(`/accounts/duplicateCheck/${encodeURIComponent(this.managerId.trim())}`);
          if (
            response &&
            (response.status === 200 || response.status === 201) &&
            !response.data
            ) {
              managerIdMsgW.setAttribute("class", "managerIdMsgW success");
              managerIdMsgW.innerHTML = "사용 가능한 아이디입니다.";
              this.isManagerIdValid = true;
              // 엘스부터 시작.
              } else {
                managerIdMsgW.setAttribute("class", "managerIdMsgW fail");
                managerIdMsgW.innerHTML = "이미 존재하는 아이디입니다.";
                this.isManagerIdValid = false;
            }
        } catch (error) {
          console.log(error);
          // 숫자 10자리(사업자번호 모양) 등 서버가 막은 이유를 그대로 보여준다.
          managerIdMsgW.setAttribute("class", "managerIdMsgW fail");
          managerIdMsgW.textContent = error.response?.data?.message || "아이디 중복확인에 실패했습니다. 다시 시도해 주세요.";
          this.isManagerIdValid = false;
        }
      }
    },

    // 비밀번호
    passwordOnChange() {
      const passwordMsg = document.querySelector(".passwordMsgW");
      if(this.password && (this.password !== this.passwordConfirm)) {
        passwordMsg.innerHTML = "비밀번호가 일치하지 않습니다.";
        this.isPasswordValid = false;
      } else {
        passwordMsg.innerHTML = "";
        this.isPasswordValid = true;
      }
    },
 

    // 파일첨부 창이 잘 안떠서 별도로 만든 클릭 메소드
    openBusinessFileInput() {
      this.$refs.businessFileInputW.click();
    },

    openLogoFileInput() {
      this.$refs.logoFileInputW.click();
    },

    openBannerFileInput() {
      this.$refs.bannerFileInputW.click();
    },

    // 파일 형식 검증
    validateFile(file) {
      let result = true;
      if (
        file.type !== 'image/png' &&
        file.type !== 'image/jpeg' &&
        file.type !== 'image/jpg'
      ) {
        alert('png, jpeg, jpg 파일만 첨부 가능합니다.');
        result = false;
      } else if (changeBytesToKilos(file.size) > 100) {
        alert('파일 크기가 100MB를 초과합니다.');
        result = false;
      }
      return result;
    },

    validateFileSize(file) {
      let result = true;
      if (changeBytesToKilos(file.size) > 100) {
        alert('파일 크기가 100MB를 초과합니다.');
        result = false;
      }
      return result;
    },

    // 사업자등록증 이미지 onChange메소드
    changeBusinessNumImage() {
      const fileInput = document.getElementById("businessFileInputW");
      if (fileInput.files && fileInput.files[0]) {
        const validateFileSize = this.validateFileSize(fileInput.files[0]);
        if(validateFileSize) {
          this.businessFileName = fileInput.files[0].name;
          const formData = new FormData();
          formData.append("file", fileInput.files[0]);
          this.businessFileData = formData;
        }
      }
    },
    deleteBusinessNumImage(){
      this.businessFileData = null;
      this.businessFileName = '';
      this.businessImgUrl = '';
    },

    // 사업자등록증 다운로드
    downloadBusinessNumImage() {
      const fileInput = this.$refs.businessFileInputW;
      const file = fileInput.files[0];
      if (file) {
        const downloadLink = document.createElement("a");
        downloadLink.href = URL.createObjectURL(file);
        downloadLink.download = file.name;
        downloadLink.click();
      }
    },
    deleteLogoImage() {
      this.logoFileData = null;
      this.logoFileName = '';
      this.logoImgUrl = '';
      document.getElementById("logoPrevW").src = "";
    },
    deleteBannerImage() {
      this.bannerFileData = null;
      this.bannerFileName = '';
      this.bannerImgUrl = '';
      document.getElementById("bannerPrevW").src = "";
    },
    // 로고 이미지 다운로드
    downloadLogoImage() {
      const fileInput = this.$refs.logoFileInputW;
      const file = fileInput.files[0];
      if (file) {
        const downloadLink = document.createElement("a");
        downloadLink.href = URL.createObjectURL(file);
        downloadLink.download = file.name;
        downloadLink.click();
      }
    },
    downloadBannerImage() {
      const fileInput = this.$refs.bannerFileInputW;
      const file = fileInput.files[0];
      if (file) {
        const downloadLink = document.createElement("a");
        downloadLink.href = URL.createObjectURL(file);
        downloadLink.download = file.name;
        downloadLink.click();
      }
    },

    // 페이지 로고 이미지 미리보기 기능 구현
    changeLogoImage() {
      const fileInput = document.getElementById("logoFileInputW");
      if (fileInput.files && fileInput.files[0]) {
        const validateFile = this.validateFile(fileInput.files[0]);
        if(validateFile) {
          const reader = new FileReader();
          reader.onload = function (e) {
            document.getElementById("logoPrevW").src = e.target.result;
          };
          reader.readAsDataURL(fileInput.files[0]);
          this.logoFileName = fileInput.files[0].name;
          document.getElementById("logoPrevW").classList.remove("hide");

          const formData = new FormData();
          formData.append("file", fileInput.files[0]);
          this.logoFileData = formData;
          console.log(this.logoFileData)
        };
      } else {
        document.getElementById("logoPrevW").src = "";
      }
    },
    // 페이지 배너 이미지 미리보기 기능 구현
    changeBannerImage() {
      const fileInput = document.getElementById("bannerFileInputW");
      if (fileInput.files && fileInput.files[0]) {
        const validateFile = this.validateFile(fileInput.files[0]);
        if(validateFile) {
          const reader = new FileReader();
          reader.onload = function (e) {
            document.getElementById("bannerPrevW").src = e.target.result;
          };
          reader.readAsDataURL(fileInput.files[0]);
          this.bannerFileName = fileInput.files[0].name;
          document.getElementById("bannerPrevW").classList.remove("hide");

          const formData = new FormData();
          formData.append("file", fileInput.files[0]);
          this.bannerFileData = formData;
          console.log(this.bannerFileData)
        };
      } else {
        document.getElementById("bannerPrevW").src = "";
      }
    },
    // 업로드 전 검증
    async validateData() {
      let result = true;
      if (this.medicalDept.length === 0) {
        await openDialog("진료 과목을 선택해 주세요.", "error", "확인");
        result = false;
      } else if( !this.selectedAreaFirst ||
        !this.selectedAreaSecond) {
        await openDialog("병원 지역을 입력해 주세요.", "error", "확인");
        result = false;
      } else if(!this.hospitalName) {
        await openDialog("병원 이름을 입력해 주세요.", "error", "확인");
        result = false;
      } else if(!this.businessNumber) {
        await openDialog("사업자등록번호를 입력해 주세요.", "error", "확인");
        result = false;
      } else if (this.businessNumber.replaceAll('-','').length < 10) {
        await openDialog("사업자등록번호를 올바르게 입력해 주세요.", "error", "확인");
        result = false;
      } else if(this.managerId && !this.isManagerIdValid) {
        await openDialog("관리자 아이디 중복확인을 해 주세요.", "error", "확인");
        result = false;
      } else if(this.managerId && !this.password) {
        await openDialog("관리자 비밀번호를 입력해 주세요.", "error", "확인");
        result = false;
      } else if(this.password && !this.passwordConfirm) {
        await openDialog("입력한 비밀번호를 다시 입력해 주세요.", "error", "확인");
        result = false;
      } else if(this.password !== this.passwordConfirm) {
        await openDialog("비밀번호가 일치하지 않습니다.", "error", "확인");
        result = false;
      } else if(!this.isBusinessNumberValid) {
        await openDialog("사업자등록번호 중복확인을 해 주세요.", "error", "확인");
        result = false;
      } 
      return result;
    },

    // 기타 hospitalInfoW용 utils
    
    // 지역 목록 가져오기
    getAreaList() {
      this.areaFirst = Object.keys(jsonFile).sort((a, b) => a.localeCompare(b, 'ko-KR'));
      this.selectedAreaFirst = "";
      this.selectedAreaSecond = "";
      this.selectedAreaThird = "";
    },

    // 시도 변화에 따른 시군구 값 넣기
    areaSecondChange() {
      if(this.selectedAreaFirst) {
        const secondLevelData = jsonFile[this.selectedAreaFirst];
        if(secondLevelData) {
          this.areaSecond = Object.keys(secondLevelData).sort((a, b) => a.localeCompare(b, 'ko-KR'));
          this.selectedAreaSecond = '';
          this.selectedAreaThird = '';
          this.areaThird = [];
        } else {
          this.selectedAreaSecond = '';
          this.selectedAreaThird = '';
          this.areaSecond = [];
          this.areaThird = [];
        }
      } else {
        this.selectedAreaSecond = "";
        this.selectedAreaThird = "";
        this.areaSecond = [];
        this.areaThird = [];
      }
    },

    // 시군구 변화에 따른 읍면동 값 넣기
    areaThirdChange() {
      if (this.selectedAreaSecond) {
        if(!jsonFile[this.selectedAreaFirst]) {
          this.selectedAreaThird = '';
          this.areaThird = [];
          return;
        }
        const thirdLevelData =
          jsonFile[this.selectedAreaFirst][this.selectedAreaSecond];
          if(thirdLevelData) {
            this.areaThird = Object.keys(thirdLevelData).sort((a, b) => a.localeCompare(b, 'ko-KR'));
            this.selectedAreaThird = '';
          } else {
            this.selectedAreaThird = '';
            this.areaThird = [];
          }
      } else {
        this.selectedAreaThird = '';
        this.areaThird = [];
      }
    },
    // 과 목록 가져오기
    async getDeptList() {
      try {
        const response = await this.$apiInstance.get(`/items/medical/depts`);
        if(response.status === 200 || response.status === 201) {
          this.deptList = response.data.filter(item => item.code !== MedicalDept.COMMON);
        }
      } catch(error) {
        console.log(error);
      }
    },
    // 의사 추가
    addRow() {
      this.doctors.push("");
    },

    // 의사 삭제
    deleteRow(index) {
      this.doctors.splice(index, 1);
      // this.doctors.push("");
    },

    // 항목 초기화 용도
    initValues() {
      this.hospitalId = "";
      this.hospitalName = "";
      this.hospitalCeoName = "";
      this.hospitalPhoneNumber = "";
      this.hospitalCode = "";
      this.businessNumber = "";
      this.managerName = "";
      this.managerPhoneNumber = "";
      this.managerId = "";
      this.password = "";
      this.passwordConfirm = "";
      this.logoImgUrl = "";
      this.bannerImgUrl = "";
      this.businessImgUrl = "";
      this.logoFileData = null;
      this.bannerFileData = null;
      this.businessFileData = null;
      this.doctors = [""];
      this.selectedAreaFirst = "";
      this.selectedAreaSecond = "";
      this.selectedAreaThird = "";
      this.addrDetail = "";
      this.selectedLocale = DEFAULT_LOCALE; // 국가 초기화

      this.isPasswordValid = false;
 
      let bFileInput;
      if(document.getElementById("businessFileInputW")) {
        bFileInput = document.getElementById("businessFileInputW").value;
        if (!bFileInput.length || bFileInput === "") {
          this.businessFileName = "";
        }
      }

      let lFileInput;
      if(document.getElementById("logoFileInputW")) {
        lFileInput = document.getElementById("logoFileInputW").value;
        if (!lFileInput.length || lFileInput === "") {
          this.logoFileName = "";
        }
      }

      let bannerFileInput;
      if(document.getElementById("bannerFileInputW")) {
        bannerFileInput = document.getElementById("bannerFileInputW").value;
        console.log(bannerFileInput);
        if (!bannerFileInput.length || bannerFileInput === "") {
          this.bannerFileName = "";
        }
      }

      // document.getElementById("logoPrevW").src = ""; // 사업자등록증
      document.getElementById("logoPrevW").src = "";
      document.getElementById("bannerPrevW").src = "";
      document.querySelector(".businessNumberMsgW").innerHTML = "";
      document.querySelector(".passwordMsgW").innerHTML = "";

      // 외부 서비스 필드 초기화 (mixin 메서드 사용)
      this.initExternalServiceValues();

      // 웹챗봇 설정 초기화
      this.useWebChatbotOnReservation = false;
      this.useOwnChatbot = false;
      this.mainChatbotId = '';
      this.chatbotList = [];
    },

    // 웹챗봇 설정 관련 메서드
    onUseWebChatbotChange(checked) {
      if (!checked) {
        // 웹챗봇 사용을 끄면 내 챗봇 사용도 끔
        this.useOwnChatbot = false;
        this.mainChatbotId = '';
      }
    },

    onUseOwnChatbotChange(checked) {
      if (!checked) {
        // 내 챗봇 사용을 끄면 선택된 챗봇 초기화
        this.mainChatbotId = '';
      }
    },

    // 외부 서비스 관련 메서드는 externalServiceMixin에서 관리
  },
};
</script>
